module.exports = __webpack_public_path__ + "img/202408_10.089ae6a6.jpg";